import * as React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Fade } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { clearBannerMessage } from '../../actions/actions';
import { MESSAGE_TYPE_INFO } from '../../global-constants';
import './styles/Banner.scss';

class BannerClass extends React.Component {
	close = () => {
		this.props.clearBanner();
	}

	render() {
		if ( this.props.banner ) {
			const { banner: { message, type, autoDismiss } } = this.props;
			let alertClasses = ['show'];

			let dismissButton = <Button bsSize="xsmall" className="close" onClick={this.close}>x</Button>;
			if (autoDismiss) {
				dismissButton = null;
				setTimeout(this.close, 5000);
			} else {
				alertClasses.push('alert-dismissable');
			}

			const style = type || MESSAGE_TYPE_INFO;
			const bannerIcon = (
				<div className='alert-icon'>
					<div className='icon'></div>
				</div>
			);

			if (message && message.length > 0) {
				return (
					<Fade in={true} unmountOnExit>
						<Alert bsStyle={style} className={alertClasses.join(' ')} >
							{bannerIcon}
							{message}
							{dismissButton}
						</Alert>
					</Fade>
				);
			}
		}
		return null;
	}
}

BannerClass.propTypes = {
	clearBanner: PropTypes.func.isRequired,
	banner: PropTypes.shape({}),
};

BannerClass.defaultPropTypes = {
	banner: {},
}

const mapDispatchToProps = dispatch => ({
	clearBanner: () => { dispatch(clearBannerMessage()) },
});

const mapStateToProps = (state) => ({
	banner: state.banner,
});

const Banner = connect(
	mapStateToProps,
	mapDispatchToProps
)(BannerClass);

export default Banner;
